import React, { useEffect, useState } from 'react';
import { Link as GatsbyLink } from 'gatsby'
import {
    Heading,
    Box,
    Flex,
} from '@chakra-ui/react'
import IconBar from './IconBar';
import Navbar from './Navbar/Navbar';
import SubNavbar from './Navbar/SubNavbar';
import useScrollDirection from '../../hooks/useScrollDirection';
import SidewideAlert from '../SitewideAlert/SitewideAlert';
import AlertModal from "../AlertModal/AlertModal"


const Header = (props) => {
    const { alert } = props;
    console.log('alert', alert)

    const scrollDirection = useScrollDirection();
    const [isVisible, setIsVisible] = useState(true);
    
    // Hide the top header when scrolling down and show it only when back at the top of the page
    const listenToScroll = () => {
        let heightToHideFrom = 200;
        const windowScroll = document.body.scrollTop || document.documentElement.scrollTop;
        if (windowScroll > heightToHideFrom) {
            setIsVisible(false);
        } else {
            setIsVisible(true);
        }
    }
    
    useEffect(() => {
        window.addEventListener("scroll", listenToScroll);
        return () =>
            window.removeEventListener("scroll", listenToScroll);
    }, [isVisible]
    );    


    return (
        // To do: make the top header hidden when scrolling up unless at the top of the page
        <>
            {alert && <SidewideAlert alert={alert} /> }
            {alert && <AlertModal alert={alert} />}
            <Box className={`header ${ scrollDirection === 'down' ? 'hide' : scrollDirection === 'up' ? 'up' : 'show' }`}
                as="header"
                bg="white"
                display={{ base: 'none', lg: 'block' }}
                    >
                <Flex px={[0, 2, 4]} pt={[2, 4]}  w="100%" 
                    justifyContent="space-between"
                    alignItems="center"
                    flexDir={{base: 'column-reverse', lg: 'row'}}
                    borderBottom="1rem solid #70A37F"
                    height="6.5rem"
                >
                    <Box w={{base: '100%', lg: '70%'}} as={GatsbyLink} to="/">
                        <Heading variant="h1" textAlign={{base: 'center', lg: 'left'}} fontSize={{base: '2rem', md: '3rem', lg: '3rem', xl: '4rem'}} _hover={{color: 'blue.500'}}>Discover Teton Valley</Heading>
                    </Box>
                    <Box w={{base: '100%', md: '100%', lg: '30%'}}>
                        <IconBar />
                    </Box>
                </Flex>
                
                <Navbar pageLocation={props.location}/>
                <SubNavbar 
                    pageLocation={props.location}
                />
            </Box>
            
            <Box
                as="header"
                bg="white"
                display={{ base: 'block', lg: 'none' }}
                // position="sticky"
                // top="0"
                zIndex={1}
                boxShadow="sm"
                className={`header ${ scrollDirection === 'down' ? 'hide' : scrollDirection === 'up' ? 'mobile-up' : 'show' }`}
                    >
                <Box w={{base: '100%', md: '100%', lg: '30%'}}
                    mt="2"
                >
                    <Box w={{base: '100%', lg: '70%'}} as={GatsbyLink} to="/">
                        <Heading variant="h1" textAlign={{base: 'center', lg: 'left'}} fontSize="1.5rem" _hover={{color: 'blue.500'}}>Discover Teton Valley</Heading>
                    </Box>
                    <IconBar />
                </Box>
               
            </Box>
            {/* <Flex px={[0, 2, 4]} pt={[2, 4]}  w="100%" 
                    justifyContent="space-between"
                    alignItems="center"
                    flexDir={{base: 'column-reverse', lg: 'row'}}
                    borderBottom={{base: "none", lg: "0.8rem solid #70A37F"}}
                    display={{ base: 'flex', md: 'none' }}
                >
                    <Box w={{base: '100%', lg: '70%'}} as={GatsbyLink} to="/">
                        <Heading variant="h1" textAlign={{base: 'center', lg: 'left'}} fontSize={{base: '2rem', md: '3rem', lg: '3rem', xl: '4rem'}} _hover={{color: 'blue.500'}}>Discover Teton Valley</Heading>
                    </Box>
                    
                </Flex> */}
        </>
    )
}

export default Header;